import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { translations } from './AccountStandingOrders.constants'
import * as S from './AccountStandingOrders.styles'

export const AccountStandingOrdersStatus = ({
  status,
  className
}: {
  status: number
  className?: string
}) => {
  const { formatMessage } = useIntl()

  return (
    <span
      className={twMerge(
        S.ItemStatus,
        status ? 'bg-accentGreen' : 'bg-accentYellow',
        className
      )}
    >
      {status
        ? formatMessage(translations.orderStatusActive)
        : formatMessage(translations.orderStatusInactive)}
    </span>
  )
}
